<div class="container">
    <div class="row justify-content-center">
        <div class="col col-xl-4 col-lg-6 col-md-8 col-sm-12 text-center coolfont heading mat-elevation-z8"><h1>Sign Up</h1></div>
        
    </div>
    <div class="row justify-content-center">
        <div class="col col-xl-4 col-lg-6 col-md-8 col-sm-12 mat-elevation-z8">
            <form class="planform text-center" [formGroup]="exampleForm" novalidate (ngSubmit)="goSignUp(exampleForm.value)">
                <div class="row">
                    <div class="col-12">
                    <mat-form-field>
                    <input matInput placeholder="E-mail" class="form-control" formControlName="uname">
                    </mat-form-field>
                    <ng-container *ngFor="let validation of validation_messages.uname">
                    <mat-error *ngIf="exampleForm.get('uname').hasError(validation.type) && (exampleForm.get('uname').dirty || exampleForm.get('uname').touched)">{{validation.message}}</mat-error>
                    </ng-container>
                    </div>
                </div>
                    <div class="row">
                    <div class="col-12">
                        <mat-form-field>
                        <input matInput placeholder="Password" type="password" class="form-control" formControlName="pwd">
                        </mat-form-field>
                        <ng-container *ngFor="let validation of validation_messages.pwd">
                        <mat-error *ngIf="exampleForm.get('pwd').hasError(validation.type) && (exampleForm.get('pwd').dirty || exampleForm.get('pwd').touched)">{{validation.message}}</mat-error>
                        </ng-container>
                    </div>
                </div>
                <div>
                    <button mat-raised-button class="signup" type="submit" [disabled]="!exampleForm.valid">Sign Up</button>
                </div>
                <br>
                <div>
                    <p>Already have a account?</p>
                    <button mat-raised-button class="signin" (click)='goSignIn()' >Sign In</button>
                </div>
                <br>
            </form>
        </div>
    </div>
</div>